import { Box, Stack } from '@mui/material'
import { SwiperSlide } from 'swiper/react'
import { StandardCard } from '@components/common/Cards/StandardCard'
import { STYLE_SIZE_CONSTANTS, getStyles } from '@utils/styles'
import { CarouselSection } from '../../CarouselSection'
import defaultStyles from '../styles'
import type { BannerProps } from '..'

type Props = Pick<
  BannerProps,
  'statsCardData' | 'cardType' | 'isBlogPage' | 'cardWrapperStyle'
>

export function MobileOnlyCardsSlider({
  statsCardData,
  cardWrapperStyle,
}: Props) {
  const styles = getStyles(defaultStyles)
  return (
    !!statsCardData?.length && (
      <CarouselSection
        swiperOptions="autoSlideView"
        realSwiperOptions={{
          pagination: {
            clickable: true,
          },
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          loop: true,
        }}
        disableArrow
        csx={{
          wrapper: {
            position: 'absolute',
            transform: 'translate(0%, -46%)',
            zIndex: 1,
            display: {
              xs: 'block',
              md: 'none',
            },
            padding: `0px ${STYLE_SIZE_CONSTANTS.sectionWrapperPadding.mobileLeftRightPadding}`,
          },
        }}
      >
        <Box
          {...styles('cardsWrapper', {
            display: {
              xs: 'none',
              md: 'flex',
            },
          })}
        >
          {statsCardData.map((item, idx) => (
            <SwiperSlide key={idx}>
              <Stack
                {...styles('cardWrapper', {
                  maxWidth: '100%',
                })}
                spacing={2}
              >
                <StandardCard
                  {...item}
                  csx={{
                    card: {
                      flex: 1,
                      ...cardWrapperStyle,
                      minWidth: 'unset !important',
                    },
                    cardMedia: {
                      minWidth: 'unset !important',
                    },
                  }}
                />
              </Stack>
            </SwiperSlide>
          ))}
        </Box>
      </CarouselSection>
    )
  )
}
